import React, { useState, useEffect, useRef, useCallback } from 'react'

import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CImage,
  CInputGroup,
  CInputGroupText,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CSpinner,
  CToast,
  CToastBody,
  CToastClose,
  CToaster,
} from '@coreui/react'

import {
  commonService,
  countryService,
  memberService,
  organeService,
  provinceService,
} from 'src/server'
import { dateUtil } from 'src/util'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import CIcon from '@coreui/icons-react'
import {
  cilCamera,
  cilCheckAlt,
  cilCheckCircle,
  cilCropRotate,
  cilImage,
  cilMediaRecord,
  cilXCircle,
  cilZoom,
} from '@coreui/icons'
import { SET_CURRENT_PAGE } from 'src/redux/actions/types'
import { useDispatch, useSelector } from 'react-redux'
import {
  CELL_ID,
  COORDINATION_ID,
  FEDERATION_ID,
  INTERFEDERATION_ID,
  PRESIDENCE_ID,
  SECRETARY_ID,
  SECTION_ID,
} from 'src/constants'

import femaleIcon from 'src/assets/images/icons/female.png'
import logo from 'src/assets/images/icons/logo100x100.png'
import Webcam from 'react-webcam'
import Cropper from 'react-easy-crop'
import getCroppedImg from 'src/util/cropImage'
import { fetchAutoEnrolled } from 'src/redux/actions/memberActions'

const defaultMember = {
  address: {
    line1: '',
    line2: '',
    number: '',
    quarter: null,
    city: null,
    country: null,
  },
  birthCountry: null,
  birthDate: null,
  birthPlace: '',
  category: {
    id: 'M',
    name: 'Membre Effectif',
  },
  currentAffectation: {
    affectationDate: null,
    createdAt: null,
    federation: null,
    coordination: null,
    interfederation: null,
    id: '',
    isValid: 1,
    section: null,
    cell: null,
    updatedAt: null,
  },
  email: null,
  fatherFullName: null,
  firstName: '',
  id: '',
  lastName: '',
  maritalStatus: 'CÉLIBATAIRE',
  memberCode: '',
  middleName: '',
  motherFullName: null,
  originQuarter: null,
  phoneNumber: null,
  photo: {
    data: null,
  },
  religiousDenomination: null,
  sex: 'M',
  subscriptionDate: null,
  updatedAt: '2023-03-22 06:20:18',
  vitalStatus: 'Vivant',
}

const PAGE_ID = 'MemberEdit'

const MemberEdit = () => {
  const abortController = new AbortController()
  const { signal } = abortController

  const [member, setMember] = useState(null)
  const [memberData, setMemberData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [countries, setCountries] = useState([])
  const [provinces, setProvinces] = useState([])
  const [denominations, setDenominations] = useState([])
  const [categories, setCategories] = useState([])
  const [idTypes, setIdTypes] = useState([])
  const [step1, setStep1] = useState(true)
  const [step2, setStep2] = useState(false)
  const [step3, setStep3] = useState(false)
  const [chosenOrgane, setChosenOrgane] = useState(null)
  const [saveModalVisible, setSaveModalVisible] = useState(false)
  const [successAlertVisible, setSucessAlertVisible] = useState(false)
  const [failureAlertVisible, setFailureAlertVisible] = useState(false)
  const hasPhotoChangedRef = useRef(false)
  const hasCardIllustrationChangedRef = useRef(false)

  const [imageScale, setImageScale] = useState(1)

  const [toast, addToast] = useState(0)
  const [autoEnroll, setAutoEnroll] = useState(false)
  const toaster = useRef()

  const user = useSelector((state) => state.users.currentUser)

  const { memberId } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    dispatch({
      type: SET_CURRENT_PAGE,
      payload: PAGE_ID,
    })
    setAutoEnroll(location.pathname.toLowerCase().includes('enroll'))
    loadDependantData()
  }, [location])

  useEffect(() => {
    loadData(memberId)
  }, [memberId])

  useEffect(() => {
    const _data = { ...memberData }
    const affectation = chosenOrgane
      ? {
          federation:
            chosenOrgane.type.id == SECTION_ID
              ? chosenOrgane.parent
              : chosenOrgane.type.id == CELL_ID
              ? chosenOrgane.parent.parent
              : chosenOrgane,
          section:
            chosenOrgane.type.id == FEDERATION_ID
              ? null
              : chosenOrgane.type.id == CELL_ID
              ? chosenOrgane.parent
              : chosenOrgane,
          cell: chosenOrgane.type.id == CELL_ID ? chosenOrgane : null,
          affectationDate: !_data.id ? dateUtil.formatDateDB(new Date()) : _data.subscriptionDate,
        }
      : null
    if (affectation?.federation) {
      if (affectation.federation.parent.type.id == COORDINATION_ID)
        affectation.federation.coordination = affectation.federation.parent
      else {
        affectation.federation.interfederation = affectation.federation.parent
        affectation.federation.coordination = affectation.federation.parent.parent
      }
    }

    _data.currentAffectation = affectation
    setMemberData(_data)
  }, [chosenOrgane])

  const successToast = (msg) => (
    <CToast color="success" className="text-white align-items-center">
      {' '}
      <div className="d-flex">
        <CToastBody>{msg}</CToastBody>
        <CToastClose className="me-2 m-auto" />{' '}
      </div>
    </CToast>
  )

  const failureToast = (msg) => (
    <CToast color="danger" className="text-white align-items-center">
      {' '}
      <div className="d-flex">
        <CToastBody>{msg}</CToastBody>
        <CToastClose className="me-2 m-auto" />{' '}
      </div>
    </CToast>
  )

  const changeStep = (step) => {
    if (step === 1) {
      setStep1(true)
      setStep2(false)
      setStep3(false)
    } else if (step === 2) {
      setStep1(false)
      setStep2(true)
      setStep3(false)
    } else if (step === 3) {
      setStep1(false)
      setStep2(false)
      setStep3(true)
    }
  }

  const loadDependantData = async () => {
    await Promise.all([
      countryService.getAll(signal).then((d) => setCountries(d)),
      provinceService.getAll().then((d) => setProvinces(d)),
      commonService.getAll('id_types', signal).then((d) => setIdTypes(d)),
      commonService.getAll('religious_denominations', signal).then((d) => setDenominations(d)),
      commonService.getAll('member_categories', signal).then((d) => setCategories(d)),
    ])
  }

  const loadData = async (id) => {
    if (!memberId) {
      setMember({ ...defaultMember })
      setMemberData({ ...defaultMember })
      return
    }
    try {
      setLoading(true)
      const _data = await memberService.get(id, signal)
      setMember(_data)
      setMemberData(_data)

      setLoading(false)
    } catch (error) {
      console.error(error)
    }
  }

  const address = (member) => {
    if (!member) return ''
    let address = member.address.line1 + ', ' + member.address.number + ', '
    if (member.address.quarter) {
      const quarter = member.address.quarter
      address += quarter.type + ' ' + quarter.name
      address += ', ' + quarter.commune?.type + ' ' + quarter.commune?.name
      address += ', ' + quarter.commune?.zone?.type + ' ' + quarter.commune?.zone?.name
      address += ', Province ' + quarter.commune?.zone?.province?.name
    }

    if (member.address.city) {
      const city = member.address.city
      address += city.name
      address += ', ' + city.country?.name
    } else if (member.address.country) {
      const country = member.address.country
      address += ', ' + country.name
    }

    return address
  }

  const origin = () => {
    let origin = ''
    if (memberData.originVillage) {
      const village = memberData.originVillage
      origin += 'Village ' + village.name + ', '
    }
    if (memberData.originQuarter) {
      const quarter = memberData.originQuarter
      origin += quarter.type + ' ' + quarter.name
      origin += ', ' + quarter.commune.type + ' ' + quarter.commune.name
      origin += ', ' + quarter.commune.zone.type + ' ' + quarter.commune.zone.name
      origin += ', Province ' + quarter.commune.zone.province.name
    }

    return origin
  }

  const SEXES = [
    { label: 'Homme', value: 'M' },
    { label: 'Femme', value: 'F' },
  ]

  const MARITAL_STATES = ['CÉLIBATAIRE', 'MARIÉ', 'VEUF', 'DIVORCÉ']
  const LINES_TYPES = ['AVENUE', 'RUE', 'BOULEVARD']
  const sleep = (time) => new Promise((resolve) => setTimeout(() => resolve(), time))

  const PersonalInfo = () => {
    const [validated, setValidated] = useState(false)
    const [originTerritories, setOriginTerritories] = useState([])
    const [originSectors, setOriginSectors] = useState([])
    const [originQuarters, setOriginQuarters] = useState([])
    const [originVillages, setOriginVillages] = useState([])
    const [addressTerritories, setAddressTerritories] = useState([])
    const [addressSectors, setAddressSectors] = useState([])
    const [addressQuarters, setAddressQuarters] = useState([])
    const [addressVillages, setAddressVillages] = useState([])
    const [cities, setCities] = useState([])
    const [isLocal, setIsLocal] = useState(true)
    const [addressCountry, setAddressCountry] = useState(null)
    const [loading, setLoading] = useState(false)

    const init = useRef()
    const lastNameRef = useRef()
    const middleNameRef = useRef()
    const firstNameRef = useRef()
    const sexRef = useRef()
    const maritalStatusRef = useRef()
    const birthDateRef = useRef()
    const birthPlaceRef = useRef()
    const birthCountryRef = useRef()
    const originProvinceIdRef = useRef()
    const originTerritoryIdRef = useRef()
    const originSectorIdRef = useRef()
    const originQuarterIdRef = useRef()
    const originVillageIdRef = useRef()
    const fatherFullNameRef = useRef()
    const motherFullNameRef = useRef()

    const addressCountryIdRef = useRef()
    const addressCityIdRef = useRef()
    const addressProvinceIdRef = useRef()
    const addressTerritoryIdRef = useRef()
    const addressSectorIdRef = useRef()
    const addressQuarterIdRef = useRef()
    const addressVillageIdRef = useRef()
    const addressLineTypeRef = useRef()
    const addressLineRef = useRef()
    const addressNumberRef = useRef()
    const telephoneRef = useRef()
    const emailRef = useRef()

    const religiousDenominationIdRef = useRef()
    const photoFileRef = useRef()
    const [photoSrc, setPhotoSrc] = useState(null)
    const [webcamPhotoSrc, setWebCamPhotoSrc] = useState(null)

    const cardTypeIdRef = useRef()
    const idCardFileRef = useRef()
    const idCardAttributionDateRef = useRef()
    const idCardInvalidationDateRef = useRef()
    const idCardNumberRef = useRef()
    const [cardSrc, setCardSrc] = useState(null)
    const [cardType, setCardType] = useState(null)

    const changeCardType = (id) => {
      setCardType(idTypes.find((t) => t.id == id))
    }

    const [webCamModalVisible, setWebCamModalVisible] = useState(false)
    const [showWebCam, setShowWebCam] = useState(true)

    useEffect(() => {
      if (!memberData) return

      lastNameRef.current.value = memberData?.lastName ?? ''
      middleNameRef.current.value = memberData?.middleName ?? ''
      firstNameRef.current.value = memberData?.firstName ?? ''
      sexRef.current.value = memberData?.sex ?? 'M'
      maritalStatusRef.current.value = memberData?.maritalStatus ?? 'M'
      birthDateRef.current.value =
        dateUtil.formatDateDB(memberData?.birthDate) ?? dateUtil.formatDateDB(new Date())
      birthPlaceRef.current.value = memberData?.birthPlace ?? ''
      fatherFullNameRef.current.value = memberData?.fatherFullName ?? ''
      motherFullNameRef.current.value = memberData?.motherFullName ?? ''
      birthCountryRef.current.value = memberData?.birthCountry?.code ?? 'COD'
      telephoneRef.current.value = memberData.phoneNumber ?? ''
      emailRef.current.value = memberData.email ?? ''
      religiousDenominationIdRef.current.value = memberData?.religiousDenomination?.id ?? null
      addressLineTypeRef.current.value = memberData?.address?.lineType ?? 'AVENUE'
      addressNumberRef.current.value = memberData?.address?.number ?? ''
      addressLineRef.current.value = memberData?.address?.line1 ?? ''
      setPhotoSrc(memberData?.photo?.media ?? memberData?.photo?.photoUrl)

      idCardAttributionDateRef.current.value = memberData.idCard?.attributionDate
        ? dateUtil.formatDateDB(memberData.idCard.attributionDate)
        : dateUtil.formatDateDB(new Date())
      idCardInvalidationDateRef.current.value = memberData.idCard?.invalidationDate
        ? dateUtil.formatDateDB(memberData.idCard.invalidationDate)
        : null
      idCardNumberRef.current.value = memberData.idCard?.number ?? ''
      setCardSrc(memberData.idCard?.illustration ?? memberData.idCard?.illustrationUrl)
      cardTypeIdRef.current.value = memberData?.idCard?.type?.id

      if (cardTypeIdRef.current.value) {
        setCardType(idTypes.find((t) => t.id == cardTypeIdRef.current.value))
      }
    }, [memberData])

    const handleSubmit = (event) => {
      event.preventDefault()
      const form = event.currentTarget
      if (form.checkValidity() === false) {
        event.stopPropagation()
      } else {
        const data = { ...memberData }
        if (photoSrc && photoSrc !== data.photo?.photoUrl) {
          if ('photo' in data) {
            data.photo.media = photoSrc
            data.photo.hasChanged = true
          } else {
            data.photo = { media: photoSrc }
          }
        } else {
          if ('photo' in data) delete data.photo
        }
        data.lastName = lastNameRef.current.value
        data.middleName = middleNameRef.current.value
        data.firstName = firstNameRef.current.value
        data.sex = sexRef.current.value
        data.maritalStatus = maritalStatusRef.current.value
        data.birthPlace = birthPlaceRef.current.value
        data.birthDate = dateUtil.formatDateDB(birthDateRef.current.value)
        data.birthCountry = birthCountryRef.current.value
          ? countries.find((d) => d.code == birthCountryRef.current.value)
          : null
        data.phoneNumber = telephoneRef.current.value
        data.email = emailRef.current.value
        data.motherFullName = motherFullNameRef.current.value
        data.fatherFullName = fatherFullNameRef.current.value
        data.religiousDenomination = religiousDenominationIdRef.current.value
          ? denominations.find((d) => d.id == religiousDenominationIdRef.current.value)
          : null
        data.fullName = `${data.lastName} ${data.middleName} ${data.firstName}`
        data.address = {}
        data.address.lineType = addressLineTypeRef.current.value
        data.address.line1 = addressLineRef.current.value
        data.address.number = addressNumberRef.current.value

        data.address.country = addressCountryIdRef.current.value
          ? countries.find((c) => c.code == addressCountryIdRef.current.value)
          : null

        if (data.address.country) {
          if (data.address.country.code !== 'COD') {
            data.address.city = addressCityIdRef.current.value
              ? cities.find((c) => c.id == addressCityIdRef.current.value)
              : null
            if (data.address.city) data.address.city.country = data.address.country
          } else {
            data.address.village = addressVillageIdRef.current.value
              ? addressVillages.find((c) => c.id == addressVillageIdRef.current.value)
              : null

            let addressQuarter = null
            if (addressQuarterIdRef.current.value) {
              addressQuarter = addressQuarters.find(
                (c) => c.id == addressQuarterIdRef.current.value,
              )
              addressQuarter.commune = addressSectors.find(
                (c) => c.id == addressSectorIdRef.current.value,
              )
              addressQuarter.commune.zone = addressTerritories.find(
                (c) => c.id == addressTerritoryIdRef.current.value,
              )
              addressQuarter.commune.zone.province = provinces.find(
                (c) => c.id == addressProvinceIdRef.current.value,
              )

              data.address.quarter = addressQuarter
            }
          }

          data.originVillage = originVillageIdRef.current.value
            ? originVillages.find((v) => v.id == originVillageIdRef.current.value)
            : null

          let originQuarter = null
          if (originQuarterIdRef.current.value) {
            originQuarter = originQuarters.find((q) => q.id == originQuarterIdRef.current.value)
            originQuarter.commune = originSectors.find(
              (q) => q.id == originSectorIdRef.current.value,
            )
            originQuarter.commune.zone = originTerritories.find(
              (q) => q.id == originTerritoryIdRef.current.value,
            )
            originQuarter.commune.zone.province = provinces.find(
              (q) => q.id == originProvinceIdRef.current.value,
            )
          }

          data.originQuarter = originQuarter

          const idCard = memberData.idCard ?? {}
          idCard.type = idTypes.find((t) => t.id == cardTypeIdRef.current.value)
          idCard.number = idCardNumberRef.current.value
          idCard.attributionDate = idCardAttributionDateRef.current.value
          idCard.invalidationDate = idCardInvalidationDateRef.current.value ?? null

          if (cardSrc && cardSrc !== idCard.illustrationUrl) {
            idCard.illustration = cardSrc
          }
          data.idCard = idCard

          setMemberData(data)
          const address = {
            country_code: data.address.country.code,
          }
          if (address.country_code === 'COD') {
            address.quarter_id = data.address.quarter.id
            address.commune_id = data.address.quarter.commune.id
          }

          if (!('category' in data)) {
            data.category = {
              id: 'M',
              name: 'Membre Effectif',
            }
          }
          setLoading(true)
          organeService.getByAddress(address).then((o_) => {
            setChosenOrgane(o_)
            setLoading(false)
            changeStep(2)
          })
        }
      }

      setValidated(true)
    }

    useEffect(() => {
      const change = async () => {
        init.current = true
        if (provinces.length) {
          await sleep(100)
          await changeOriginProvince(
            memberData.originQuarter?.commune?.zone?.province?.id ?? provinces[0].id,
          )
          await changeAddressProvince(
            memberData.address?.quarter?.commune?.zone?.province?.id ?? provinces[0].id,
          )
          init.current = false
        }
      }
      change()
    }, [provinces])

    useEffect(() => {
      const change = async () => {
        birthCountryRef.current.value = memberData?.birthCountry?.code ?? 'COD'
        await changeAddressCountry(memberData?.address?.country?.code ?? 'COD')
      }
      change()
    }, [countries])

    const chooseImage = (ev, setter, source) => {
      if (ev.target.files.length > 0) {
        var fileToLoad = ev.target.files[0]
        var fileReader = new FileReader()
        var ext = fileToLoad.name.split('.').pop()

        fileReader.onload = function (e) {
          var srcData = e.target.result // <--- data: base64
          setter(srcData)
          if (source === 'Photo') {
            hasPhotoChangedRef.current = true
            setShowWebCam(false)
            setWebCamModalVisible(true)
          }
          if (source === 'Illustration') hasCardIllustrationChangedRef.current = true
        }

        fileReader.readAsDataURL(fileToLoad)
      }
    }

    const changeAddressCountry = async (code) => {
      const data = countries.find((c) => c.code == code)
      addressCountryIdRef.current.value = data?.code
      setAddressCountry(data)
      setIsLocal(code === 'COD')
      await sleep(100)

      if (code !== 'COD') await loadAddressCities(data)
    }

    const changeOriginProvince = async (id) => {
      await sleep(100)
      const data = provinces.find((c) => c.id == id)
      originProvinceIdRef.current.value = data?.id
      await loadOriginTerritories(data)
    }

    const changeOriginTerritory = async (id, items = null) => {
      await sleep(100)
      const data = (items ?? originTerritories).find((c) => c.id == id)
      if (originTerritoryIdRef.current) originTerritoryIdRef.current.value = id
      await loadOriginSectors(data)
    }

    const changeOriginSector = async (id, items = null) => {
      await sleep(100)
      const data = (items ?? originSectors).find((c) => c.id == id)
      originSectorIdRef.current.value = data?.id
      await loadOriginQuarters(data)
    }

    const changeOriginQuarter = async (id, items = null) => {
      await sleep(100)
      const data = (items ?? originQuarters).find((c) => c.id == id)
      originQuarterIdRef.current.value = data?.id
      await loadOriginVillages(data)
    }

    const changeOriginVillage = async (id, items = null) => {
      await sleep(100)
      const data = (items ?? originVillages).find((c) => c.id == id)
      originVillageIdRef.current.value = data?.id
    }

    const loadAddressCities = async (country) => {
      if (!country) {
        setCities([])
        return
      }
      try {
        const items = country.cities.data ?? (await commonService.load(country.cities.href))
        country.cities.data = items

        setCities(items)
        if (items.length) {
          const id = memberData?.address?.city?.id ?? items[0].id
          await changeAddressCity(id, items)
        }
      } catch (error) {
        console.error(error)
        setCities([])
      }
    }

    const changeAddressCity = async (id, items = null) => {
      await sleep(100)
      const data = (items ?? cities).find((c) => c.id == id)
      addressCityIdRef.current.value = data?.id
    }

    const loadOriginTerritories = async (province) => {
      if (!province) {
        setOriginTerritories([])
        return
      }

      const items =
        province.territoires_villes.data ??
        (await commonService.load(province.territoires_villes.href))
      province.territoires_villes.data = items

      setOriginTerritories(items)
      if (items.length) {
        const id =
          init.current && memberData?.originQuarter?.commune?.zone?.id
            ? memberData?.originQuarter?.commune?.zone?.id
            : items[0].id
        await changeOriginTerritory(id, items)
      }
    }

    const loadOriginSectors = async (territory) => {
      if (!territory) {
        setOriginSectors([])
        return
      }

      const items = territory.communes.data ?? (await commonService.load(territory.communes.href))
      territory.communes.data = items
      setOriginSectors(items)
      if (items.length) {
        const id =
          init.current && memberData?.originQuarter?.commune?.id
            ? memberData?.originQuarter?.commune?.id
            : items[0].id
        await changeOriginSector(id, items)
      }
    }

    const loadOriginQuarters = async (sector) => {
      if (!sector) {
        setOriginQuarters([])
        return
      }

      const items = sector.quartiers.data ?? (await commonService.load(sector.quartiers.href))
      sector.quartiers.data = items
      setOriginQuarters(items)
      if (items.length) {
        const id =
          init.current && memberData?.originQuarter?.id
            ? memberData?.originQuarter?.id
            : items[0].id
        await changeOriginQuarter(id, items)
      }
    }

    const loadOriginVillages = async (quarter) => {
      if (!quarter) {
        setOriginVillages([])
        return
      }

      const items = quarter.villages.data ?? (await commonService.load(quarter.villages.href))
      quarter.villages.data = items
      setOriginVillages(items)
      if (items.length) {
        const id =
          init.current && memberData?.originVillage?.id
            ? memberData?.originVillage?.id
            : items[0].id
        await changeOriginVillage(id, items)
      }
    }

    const changeAddressProvince = async (id) => {
      await sleep(100)
      const data = provinces.find((c) => c.id == id)
      if (addressProvinceIdRef.current) addressProvinceIdRef.current.value = data?.id
      await loadAddressTerritories(data)
    }

    const changeAddressTerritory = async (id, items = null) => {
      await sleep(100)
      const data = (items ?? addressTerritories).find((c) => c.id == id)
      if (addressProvinceIdRef.current) addressTerritoryIdRef.current.value = data?.id
      await loadAddressSectors(data)
    }

    const changeAddressSector = async (id, items = null) => {
      await sleep(100)
      const data = (items ?? addressSectors).find((c) => c.id == id)
      if (addressProvinceIdRef.current) addressSectorIdRef.current.value = data?.id
      await loadAddressQuarters(data)
    }

    const changeAddressQuarter = async (id, items = null) => {
      await sleep(100)
      const data = (items ?? addressQuarters).find((c) => c.id == id)
      if (addressProvinceIdRef.current) addressQuarterIdRef.current.value = data?.id
      await loadAddressVillages(data)
    }

    const changeAddressVillage = async (id, items = null) => {
      await sleep(100)
      const data = (items ?? addressVillages).find((c) => c.id == id)
      if (addressProvinceIdRef.current) addressVillageIdRef.current.value = data?.id
    }

    const loadAddressTerritories = async (province) => {
      if (!province) {
        setAddressTerritories([])
        return
      }

      const items =
        province.territoires_villes.data ??
        (await commonService.load(province.territoires_villes.href))
      province.territoires_villes.data = items

      setAddressTerritories(items)
      if (items.length) {
        const id =
          init.current && memberData?.address?.quarter?.commune?.zone?.id
            ? memberData.address.quarter.commune.zone.id
            : items[0].id
        await changeAddressTerritory(id, items)
      }
    }

    const loadAddressSectors = async (territory) => {
      if (!territory) {
        setAddressSectors([])
        return
      }

      const items = territory.communes.data ?? (await commonService.load(territory.communes.href))
      territory.communes.data = items
      setAddressSectors(items)
      if (items.length) {
        const id =
          init.current && memberData?.address?.quarter?.commune?.id
            ? memberData.address.quarter.commune.id
            : items[0].id
        await changeAddressSector(id, items)
      }
    }

    const loadAddressQuarters = async (sector) => {
      if (!sector) {
        setAddressQuarters([])
        return
      }

      const items = sector.quartiers.data ?? (await commonService.load(sector.quartiers.href))
      sector.quartiers.data = items
      setAddressQuarters(items)

      if (items.length) {
        const id =
          init.current && memberData?.address?.quarter?.id
            ? memberData.address.quarter.id
            : items[0].id
        await changeAddressQuarter(id, items)
      }
    }

    const loadAddressVillages = async (quarter) => {
      if (!quarter) {
        setAddressVillages([])
        return
      }

      const items = quarter.villages.data ?? (await commonService.load(quarter.villages.href))
      quarter.villages.data = items
      setAddressVillages(items)

      if (items.length) {
        const id =
          init.current && memberData?.address.village?.id
            ? memberData?.address.village?.id
            : items[0].id
        await changeAddressVillage(id, items)
      }
    }

    return (
      <CRow style={{ opacity: loading ? 0.3 : 1 }}>
        <CCol md={2}>
          <CFormInput
            ref={photoFileRef}
            type="file"
            accept="image/*"
            hidden
            onChange={(ev) => chooseImage(ev, setWebCamPhotoSrc, 'Photo')}
          />
          <CImage
            rounded
            thumbnail
            src={photoSrc ?? femaleIcon}
            width={200}
            height={200}
            align="start"
            onClick={() => photoFileRef.current.click()}
            style={{ display: 'block' }}
          />

          <div>
            <CButton
              color="info"
              variant="outline"
              shape="rounded-pill"
              style={{
                height: 40,
                width: 40,
                marginRight: 10,
                marginTop: 10,
              }}
              onClick={() => {
                setShowWebCam(true)
                setWebCamModalVisible(true)
              }}
            >
              <CIcon icon={cilCamera} />
            </CButton>
            <CButton
              color="info"
              variant="outline"
              shape="rounded-pill"
              style={{
                height: 40,
                width: 40,
                marginTop: 10,
              }}
              onClick={() => {
                photoFileRef.current.click()
              }}
            >
              <CIcon icon={cilImage} />
            </CButton>
          </div>
        </CCol>
        <CCol md={10}>
          <CForm
            style={{ width: '100%' }}
            className="row g-3 needs-validation"
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
          >
            <CCol md={4}>
              <CFormLabel htmlFor="nameFld">Nom</CFormLabel>
              <CFormInput
                ref={lastNameRef}
                type="text"
                id="nameFld"
                placeholder="Nom du membre"
                defaultValue=""
                required
              />
              <CFormFeedback invalid>Le nom est requis !</CFormFeedback>
            </CCol>
            <CCol md={4}>
              <CFormLabel htmlFor="middleNameFld">Post-nom</CFormLabel>
              <CFormInput
                ref={middleNameRef}
                type="text"
                id="middleNameFld"
                placeholder="Post-nom du membre"
                defaultValue=""
                required
              />
              <CFormFeedback invalid>Le post-nom est requis !</CFormFeedback>
            </CCol>
            <CCol md={4}>
              <CFormLabel htmlFor="firstNameFld">Prénom</CFormLabel>
              <CFormInput
                ref={firstNameRef}
                type="text"
                id="firstNameFld"
                placeholder="Prénom du membre"
                defaultValue=""
                required
              />
              <CFormFeedback invalid>Le prénom est requis !</CFormFeedback>
            </CCol>

            <br />
            <CCol md={4}>
              <CFormLabel htmlFor="sexFld">Sexe</CFormLabel>
              <CFormSelect ref={sexRef} id="sexFld">
                <option disabled>Choisir le sexe</option>
                {SEXES.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </CFormSelect>
              <CFormFeedback invalid>Veuillez renseigner le sexe.</CFormFeedback>
            </CCol>
            <CCol md={4}>
              <CFormLabel htmlFor="maritalStatusFld">État civil</CFormLabel>
              <CFormSelect ref={maritalStatusRef} id="maritalStatusFld">
                <option disabled>Choisir l&apos;état civil</option>
                {MARITAL_STATES.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </CFormSelect>
              <CFormFeedback invalid>Veuillez renseigner l&apos;état civil.</CFormFeedback>
            </CCol>

            <br />
            <CCol md={4}>
              <CFormLabel htmlFor="birthDateFld">Date de naissance</CFormLabel>
              <CFormInput
                ref={birthDateRef}
                type="date"
                id="birthDateFld"
                defaultValue=""
                required
              />
              <CFormFeedback invalid>La date de naissance est requise !</CFormFeedback>
            </CCol>
            <CCol md={4}>
              <CFormLabel htmlFor="birthCountryFld">Pays de naissance</CFormLabel>
              <CFormSelect id="birthCountryFld" ref={birthCountryRef}>
                <option disabled>Choisir le pays de naissance</option>
                {countries.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.name}
                  </option>
                ))}
              </CFormSelect>
              <CFormFeedback invalid>Veuillez renseigner le pays de naissance.</CFormFeedback>
            </CCol>
            <CCol md={4}>
              <CFormLabel htmlFor="birthPlaceFld">Lieu de naissance</CFormLabel>
              <CFormInput
                ref={birthPlaceRef}
                type="text"
                id="birthPlaceFld"
                placeholder="Lieu de naissance"
                defaultValue=""
                required
              />
              <CFormFeedback invalid>Le lieu de naissance !</CFormFeedback>
            </CCol>
            <div className="mb-0 mt-4 h6">Origine</div>
            <CCol md={4}>
              <CFormLabel htmlFor="originProvinceFld">Province</CFormLabel>
              <CFormSelect
                id="originProvinceFld"
                ref={originProvinceIdRef}
                onChange={(e) => changeOriginProvince(e.target.value)}
                required
              >
                <option disabled>Choisir la province d&apos;origine</option>
                {provinces.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </CFormSelect>
              <CFormFeedback invalid>Veuillez indiquer la province originaire.</CFormFeedback>
            </CCol>
            <CCol md={4}>
              <CFormLabel htmlFor="originTerritory">Ville / Territoire</CFormLabel>
              <CFormSelect
                id="originTerritory"
                ref={originTerritoryIdRef}
                onChange={(e) => changeOriginTerritory(e.target.value)}
                required
              >
                <option disabled>Choisir le territoire d&apos;origine</option>
                {originTerritories.map((item) => (
                  <option key={item.id} value={item.id}>
                    {`${item.name}`}
                  </option>
                ))}
              </CFormSelect>
              <CFormFeedback invalid>Veuillez renseigner le territoire originaire.</CFormFeedback>
            </CCol>
            <CCol md={4}>
              <CFormLabel htmlFor="originSector">Commune / Secteur / Chefferie</CFormLabel>
              <CFormSelect
                id="originSector"
                ref={originSectorIdRef}
                onChange={(e) => changeOriginSector(e.target.value)}
                required
              >
                <option disabled>Choisir le territoire d&apos;origine</option>
                {originSectors.map((item) => (
                  <option key={item.id} value={item.id}>
                    {`${item.type} ${item.name}`}
                  </option>
                ))}
              </CFormSelect>
              <CFormFeedback invalid>Veuillez renseigner le secteur originaire.</CFormFeedback>
            </CCol>
            <CCol md={4}>
              <CFormLabel htmlFor="originQuarter">Quartier / Groupement</CFormLabel>
              <CFormSelect
                id="originQuarter"
                ref={originQuarterIdRef}
                onChange={(e) => changeOriginQuarter(e.target.value)}
                required
              >
                <option disabled>Choisir le groupement d&apos;origine</option>
                {originQuarters.map((item) => (
                  <option key={item.id} value={item.id}>
                    {`${item.type} ${item.name}`}
                  </option>
                ))}
              </CFormSelect>
              <CFormFeedback invalid>Veuillez renseigner le groupement originaire.</CFormFeedback>
            </CCol>
            <CCol md={4}>
              <CFormLabel htmlFor="originVillage">Village</CFormLabel>
              <CFormSelect
                id="originVillage"
                ref={originVillageIdRef}
                onChange={(e) => changeOriginVillage(e.target.value)}
              >
                <option disabled>Choisir le village d&apos;origine</option>
                {originVillages.map((item) => (
                  <option key={item.id} value={item.id}>
                    {`${item.name}`}
                  </option>
                ))}
              </CFormSelect>
            </CCol>
            <div className="mb-0 mt-4 h6">Parents</div>
            <CCol md={6}>
              <CFormLabel htmlFor="fatherNameFld">Noms du père</CFormLabel>
              <CFormInput
                ref={fatherFullNameRef}
                type="text"
                id="fatherNameFld"
                placeholder="Nom complet du père"
                defaultValue=""
              />
              <CFormFeedback invalid>Le nom du père est requis !</CFormFeedback>
            </CCol>
            <CCol md={6}>
              <CFormLabel htmlFor="motherNameFld">Noms de la mère</CFormLabel>
              <CFormInput
                ref={motherFullNameRef}
                type="text"
                id="motherNameFld"
                placeholder="Nom complet de la mère"
                defaultValue=""
              />
              <CFormFeedback invalid>Le nom de la mère est requis !</CFormFeedback>
            </CCol>
            <div className="mb-0 mt-4 h6">Adresse</div>
            <CCol md={4}>
              <CFormLabel htmlFor="addressCountryFld">Pays de résidence</CFormLabel>
              <CFormSelect
                id="addressCountryFld"
                onChange={(e) => changeAddressCountry(e.target.value)}
                ref={addressCountryIdRef}
                required
              >
                <option disabled>Choisir le pays</option>
                {countries.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.name}
                  </option>
                ))}
              </CFormSelect>
              <CFormFeedback invalid>Veuillez renseigner le pays de résidence.</CFormFeedback>
            </CCol>
            {!isLocal && (
              <CCol md={4}>
                <CFormLabel htmlFor="addressCityFld">Ville</CFormLabel>
                <CFormSelect
                  id="addressCityFld"
                  ref={addressCityIdRef}
                  onChange={(e) => changeAddressCity(e.target.value)}
                  required
                >
                  <option disabled>Choisir la cité de résidence</option>
                  {cities.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </CFormSelect>
                <CFormFeedback invalid>Veuillez indiquer la cité de résidence.</CFormFeedback>
              </CCol>
            )}
            {isLocal && (
              <>
                <CCol md={4}>
                  <CFormLabel htmlFor="addressProvinceFld">Province</CFormLabel>
                  <CFormSelect
                    id="addressProvinceFld"
                    ref={addressProvinceIdRef}
                    onChange={(e) => changeAddressProvince(e.target.value)}
                    required
                  >
                    <option disabled>Choisir la province de résidence</option>
                    {provinces.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </CFormSelect>
                  <CFormFeedback invalid>Veuillez indiquer la province de résidence.</CFormFeedback>
                </CCol>
                <CCol md={4}>
                  <CFormLabel htmlFor="addressTerritory">Ville / Territoire</CFormLabel>
                  <CFormSelect
                    id="addressTerritory"
                    ref={addressTerritoryIdRef}
                    onChange={(e) => changeAddressTerritory(e.target.value)}
                    required
                  >
                    <option disabled>Choisir le territoire de résidence</option>
                    {addressTerritories.map((item) => (
                      <option key={item.id} value={item.id}>
                        {`${item.name}`}
                      </option>
                    ))}
                  </CFormSelect>
                  <CFormFeedback invalid>
                    Veuillez renseigner le territoire de résidence.
                  </CFormFeedback>
                </CCol>
                <CCol md={4}>
                  <CFormLabel htmlFor="addressSector">Commune / Secteur / Chefferie</CFormLabel>
                  <CFormSelect
                    id="addressSector"
                    ref={addressSectorIdRef}
                    onChange={(e) => changeAddressSector(e.target.value)}
                    required
                  >
                    <option disabled>Choisir le territoire de résidence</option>
                    {addressSectors.map((item) => (
                      <option key={item.id} value={item.id}>
                        {`${item.type} ${item.name}`}
                      </option>
                    ))}
                  </CFormSelect>
                  <CFormFeedback invalid>
                    Veuillez renseigner le secteur de résidence.
                  </CFormFeedback>
                </CCol>
                <CCol md={4}>
                  <CFormLabel htmlFor="addressQuarter">Quartier / Groupement</CFormLabel>
                  <CFormSelect
                    id="addressQuarter"
                    ref={addressQuarterIdRef}
                    onChange={(e) => changeAddressQuarter(e.target.value)}
                    required
                  >
                    <option disabled>Choisir le groupement de résidence</option>
                    {addressQuarters.map((item) => (
                      <option key={item.id} value={item.id}>
                        {`${item.type} ${item.name}`}
                      </option>
                    ))}
                  </CFormSelect>
                  <CFormFeedback invalid>
                    Veuillez renseigner le groupement de résidence.
                  </CFormFeedback>
                </CCol>
                <CCol md={4}>
                  <CFormLabel htmlFor="addressVillage">Village</CFormLabel>
                  <CFormSelect
                    id="addressVillage"
                    ref={addressVillageIdRef}
                    onChange={(e) => changeAddressVillage(e.target.value)}
                  >
                    <option disabled>Choisir le village de résidence</option>
                    {addressVillages.map((item) => (
                      <option key={item.id} value={item.id}>
                        {`${item.name}`}
                      </option>
                    ))}
                  </CFormSelect>
                </CCol>
              </>
            )}
            <CCol md={4}>
              <CFormLabel htmlFor="lineTypeFld">Type de voie</CFormLabel>
              <CFormSelect id="lineTypeFld" ref={addressLineTypeRef}>
                <option disabled>Choisir le type de voie</option>
                {LINES_TYPES.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </CFormSelect>
              <CFormFeedback invalid>Veuillez renseigner le type de votre voie.</CFormFeedback>
            </CCol>
            <CCol md={4}>
              <CFormLabel htmlFor="lineFld">Voie</CFormLabel>
              <CFormInput
                type="text"
                id="lineFld"
                placeholder="Nom de la voie"
                ref={addressLineRef}
                required
              />
              <CFormFeedback invalid>Le nom de la voie est requis.</CFormFeedback>
            </CCol>
            <CCol md={4}>
              <CFormLabel htmlFor="addressNumberFld">Numéro</CFormLabel>
              <CFormInput
                type="text"
                id="addressNumberFld"
                placeholder="Nom de la voie"
                ref={addressNumberRef}
                required
              />
              <CFormFeedback invalid>Le numéro de l&apos;adresse est requis.</CFormFeedback>
            </CCol>
            <div className="mb-0 mt-4 h6">Contacts</div>
            <CCol md={6}>
              <CFormLabel htmlFor="telephoneFld">Téléphone</CFormLabel>
              <CInputGroup className="has-validation">
                <CInputGroupText id="inputGroupPrepend">
                  {addressCountry?.indicator ?? '+243'}
                </CInputGroupText>
                <CFormInput
                  ref={telephoneRef}
                  type="phone"
                  id="telephoneFld"
                  defaultValue=""
                  aria-describedby="inputGroupPrepend"
                />
                <CFormFeedback invalid>Le numéro de téléphone est requis.</CFormFeedback>
              </CInputGroup>
            </CCol>

            <CCol md={6}>
              <CFormLabel htmlFor="emailFld">Email</CFormLabel>
              <CInputGroup className="has-validation">
                <CInputGroupText id="emailGroupPrepend">{'@'}</CInputGroupText>
                <CFormInput
                  ref={emailRef}
                  type="email"
                  id="emailFld"
                  defaultValue=""
                  aria-describedby="emailGroupPrepend"
                />
                <CFormFeedback invalid>
                  L&apos;adresse email saisi n&apos;est pas valide.
                </CFormFeedback>
              </CInputGroup>
            </CCol>

            <div className="mb-0 mt-4 h6">Réligion</div>
            <CCol md={6}>
              <CFormLabel htmlFor="relDenomFld">Confession réligieuse</CFormLabel>
              <CFormSelect id="relDenomFld" ref={religiousDenominationIdRef} required>
                <option disabled>Choisir la confession</option>
                {denominations.map((item) => (
                  <option key={item.id} value={item.id}>
                    {`${item.name}`}
                  </option>
                ))}
              </CFormSelect>
              <CFormFeedback invalid>Veuillez renseigner la confession.</CFormFeedback>
            </CCol>

            <div className="mb-0 mt-4 h6">Pièce d&apos;identité</div>
            <CCol md={3}>
              <CFormInput
                ref={idCardFileRef}
                type="file"
                accept="image/*"
                hidden
                onChange={(ev) => chooseImage(ev, setCardSrc, 'Illustration')}
              />
              <CImage
                rounded
                thumbnail
                src={cardSrc}
                width={200}
                height={200}
                align="start"
                onClick={() => {
                  if (cardType?.name?.trim() !== 'AUCUNE') idCardFileRef.current.click()
                }}
              />
              <CButton
                color="info"
                variant="outline"
                shape="rounded-pill"
                style={{
                  height: 40,
                  width: 40,
                  marginTop: 10,
                }}
                onClick={() => {
                  idCardFileRef.current.click()
                }}
                disabled={cardType?.name?.trim() == 'AUCUNE' ? true : false}
              >
                <CIcon icon={cilImage} />
              </CButton>
            </CCol>
            <CCol md={9} className="row">
              <CCol md={6}>
                <CFormLabel htmlFor="cartTypeFld">Type de pièce</CFormLabel>
                <CFormSelect
                  id="cartTypeFld"
                  ref={cardTypeIdRef}
                  required
                  onChange={(ev) => changeCardType(ev.target.value)}
                >
                  <option disabled>Choisir le type</option>
                  {idTypes.map((item) => (
                    <option key={item.id} value={item.id}>
                      {`${item.name}`}
                    </option>
                  ))}
                </CFormSelect>
                <CFormFeedback invalid>Veuillez renseigner le type de la pièce.</CFormFeedback>
              </CCol>

              <CCol md={6}>
                <CFormLabel htmlFor="idCardNumberFld">Numéro</CFormLabel>
                <CFormInput
                  type="text"
                  id="idCardNumberFld"
                  placeholder="Numéro de la pièce"
                  ref={idCardNumberRef}
                  required={cardType?.name?.trim() !== 'AUCUNE' ? true : false}
                  disabled={cardType?.name?.trim() == 'AUCUNE' ? true : false}
                />
                <CFormFeedback invalid>
                  Le numéro de la pièce d&apos;identité est requis.
                </CFormFeedback>
              </CCol>

              <CCol md={6}>
                <CFormLabel htmlFor="idCardAttributionFld">Date d&apos;attribution</CFormLabel>
                <CFormInput
                  type="date"
                  id="idCardAttributionDateFld"
                  ref={idCardAttributionDateRef}
                  required={cardType?.name?.trim() !== 'AUCUNE' ? true : false}
                  disabled={cardType?.name?.trim() == 'AUCUNE' ? true : false}
                />
                <CFormFeedback invalid>
                  La date d&apos;attribution de la pièce est requise.
                </CFormFeedback>
              </CCol>
              <CCol md={6}>
                <CFormLabel htmlFor="idCardInvalidationDateFld">
                  Date d&apos;invalidation
                </CFormLabel>
                <CFormInput
                  type="date"
                  id="idCardInvalidationDateFld"
                  ref={idCardInvalidationDateRef}
                  disabled={cardType?.name?.trim() == 'AUCUNE' ? true : false}
                />
              </CCol>
            </CCol>
            <div className="dashed-separator mt-5 mb-4" />

            <div className="d-flex justify-content-between">
              <CButton color="primary" type="submit">
                Suivant
              </CButton>
            </div>
          </CForm>
        </CCol>
        <PhotoModal
          visible={webCamModalVisible}
          setVisible={setWebCamModalVisible}
          photoSrc={webcamPhotoSrc}
          setPhotoSrc={setWebCamPhotoSrc}
          webcam={showWebCam}
          showWebcam={setShowWebCam}
          onCrop={(img) => setPhotoSrc(img)}
        />
      </CRow>
    )
  }

  const PartisanInfo = () => {
    const [validated, setValidated] = useState(false)
    const [coordinations, setCoordinations] = useState([])
    const [interOrFederations, setInterOrFederations] = useState([])
    const [federations, setFederations] = useState([])
    const [sections, setSections] = useState([])
    const [cells, setCells] = useState([])
    const [showCoordination, setShowCoordination] = useState(true)
    const [showInterOrFed, setShowInterOrFed] = useState(true)
    const [showFed, setShowFed] = useState(true)
    const [showSect, setShowSect] = useState(true)
    const [showCell, setShowCell] = useState(true)
    const [isInter, setIsInter] = useState(false)

    const defaultData = {
      coordinationId: null,
      interfederationId: null,
      federationId: null,
      sectionId: null,
      cellId: null,
    }
    const dataRef = useRef(defaultData)

    const init = useRef(false)
    const coordinationIdRef = useRef()
    const interOrFederationIdRef = useRef()
    const federationIdRef = useRef()
    const sectionIdRef = useRef()
    const cellIdRef = useRef()
    const subscriptionDateRef = useRef()

    useEffect(() => {
      subscriptionDateRef.current.value = memberData.subscriptionDate
        ? dateUtil.formatDateDB(memberData.subscriptionDate)
        : memberData.createdAt
        ? dateUtil.formatDateDB(memberData.createdAt)
        : dateUtil.formatDateDB(new Date())
    }, [memberData])

    useEffect(() => {
      subscriptionDateRef.current.value = memberData.subscriptionDate
        ? dateUtil.formatDateDB(memberData.subscriptionDate)
        : memberData.createdAt
        ? dateUtil.formatDateDB(memberData.createdAt)
        : dateUtil.formatDateDB(new Date())
    }, [chosenOrgane])

    const handleSubmit = (event) => {
      event.preventDefault()
      const form = event.currentTarget
      if (form.checkValidity() === false) {
        event.stopPropagation()
      } else {
        /*
        const _data = { ...memberData }
        _data.subscriptionDate = subscriptionDateRef.current.value
        let federation = null
        if ([PRESIDENCE_ID, SECRETARY_ID].includes(user.organe.type.id)) {
          const fedId = dataRef.current.federationId
          federation = !isInter
            ? interOrFederations.find((f) => f.id == fedId)
            : federations.find((f) => f.id == fedId)
          if (dataRef.current.interfederationId) {
            federation.interfederation = interOrFederations.find(
              (f) => f.id == dataRef.current.interfederationId,
            )
          }
          federation.coordination = coordinations.find(
            (f) => f.id == dataRef.current.coordinationId,
          )
        } else {
          if (user.organe.type.id == COORDINATION_ID) {
            const fedId = dataRef.current.federationId
            federation = !isInter
              ? interOrFederations.find((f) => f.id == fedId)
              : federations.find((f) => f.id == fedId)
            if (dataRef.current.interfederationId) {
              federation.interfederation = interOrFederations.find(
                (f) => f.id == dataRef.current.interfederationId,
              )
            }
            federation.coordination = user.organe
          } else if (user.organe.type.id == INTERFEDERATION_ID) {
            const fedId = dataRef.current.federationId
            federation = federations.find((f) => f.id == fedId)
            federation.interfederation = user.organe
            federation.coordination = user.organe.parent
          } else if (user.organe.type.id == FEDERATION_ID) {
            federation = user.organe
            federation.interfederation = user.organe.interfederation ? user.organe.parent : null
            federation.coordination = federation.interfederation
              ? federation.interfederation.parent
              : user.organe.parent
          } else if (user.organe.type.id == SECTION_ID) {
            federation = user.organe.parent
            federation.interfederation = federation.interfederation ? federation.parent : null
            federation.coordination = federation.interfederation
              ? federation.interfederation.parent
              : federation.parent
          }
        }

        const affectation = {
          federation,
          section:
            user.organe.type.id == SECTION_ID
              ? user.organe
              : dataRef.current.sectionId
              ? sections.find((f) => f.id == dataRef.current.sectionId)
              : null,
          cell: dataRef.current.cellId ? cells.find((f) => f.id == dataRef.current.cellId) : null,
          affectationDate: !_data.id ? dateUtil.formatDateDB(new Date()) : _data.subscriptionDate,
        }

        _data.currentAffectation = affectation
        _data.createdAt = _data.createdAt ?? dateUtil.formatDateHourDB(new Date())
        _data.status = _data.status ?? { id: 1, name: 'ACTIVE' }
       */

        const _data = { ...memberData }
        _data.subscriptionDate = subscriptionDateRef.current.value

        if (_data.currentAffectation) {
          _data.currentAffectation.affectationDate = !_data.id
            ? dateUtil.formatDateDB(new Date())
            : _data.subscriptionDate
        }

        _data.createdAt = _data.createdAt ?? dateUtil.formatDateHourDB(new Date())
        _data.status = _data.status ?? { id: 1, name: 'ACTIVE' }
        setMemberData(_data)
        changeStep(3)
      }

      setValidated(true)
    }

    /*
    useEffect(() => {
      if (!user || !memberData) return
      init.current = true
      const organe = user.organe
      const typeId = organe.type.id
      if (typeId == PRESIDENCE_ID || typeId == SECRETARY_ID) {
        loadCoordinations(true)
      } else if (typeId == COORDINATION_ID) {
        setShowCoordination(false)
        loadInterAndFederations(organe, true)
      } else if (typeId == INTERFEDERATION_ID) {
        setShowCoordination(false)
        setShowInterOrFed(false)
        setIsInter(true)
        loadFederations(organe, true)
      } else if (typeId == FEDERATION_ID) {
        setShowCoordination(false)
        setShowInterOrFed(false)
        setShowFed(false)
        loadSections(organe, true)
      } else if (typeId == SECTION_ID) {
        setShowCoordination(false)
        setShowInterOrFed(false)
        setShowFed(false)
        setShowSect(false)
        loadCells(organe, true)
      }
      init.current = false
    }, [user, memberData])
    */

    const changeCoordination = async (id, items = null, init = false) => {
      await sleep(100)
      const item = (items ?? coordinations).find((c) => c.id == id)
      coordinationIdRef.current.value = item?.id
      dataRef.current.coordinationId = item?.id
      await loadInterAndFederations(item, init)
    }
    const changeInterOrFederation = async (id, items = null, init = false) => {
      await sleep(100)
      const item = (items ?? interOrFederations).find((c) => c.id == id)
      interOrFederationIdRef.current.value = item?.id
      if (item) {
        if (item.type.id == 1) {
          dataRef.current = { ...dataRef.current, interfederationId: null, federationId: item.id }
          setIsInter(false)
          await loadSections(item, init)
        } else if (item.type.id == 7) {
          dataRef.current = { ...dataRef.current, interfederationId: item.id, federationId: null }
          setIsInter(true)
          await sleep(100)
          await loadFederations(item, init)
        }
      }
    }
    const changeFederation = async (id, items = null, init = false) => {
      await sleep(100)
      const item = (items ?? federations).find((c) => c.id == id)
      federationIdRef.current.value = item?.id
      dataRef.current.federationId = item?.id
      await loadSections(item, init)
    }
    const changeSection = async (id, items = null, init = false) => {
      await sleep(100)
      const item = (items ?? sections).find((c) => c.id == id)
      sectionIdRef.current.value = item?.id
      dataRef.current.sectionId = item?.id
      await loadCells(item, init)
    }
    const changeCell = async (id, items = null) => {
      await sleep(100)
      const item = (items ?? cells).find((c) => c.id == id)
      cellIdRef.current.value = item?.id
      dataRef.current.cellId = item?.id
    }

    const loadCoordinations = async (init = false) => {
      try {
        let items = await commonService.getAllBy('organe_types', 4, 'organes', signal)
        items.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
        setCoordinations(items)
        await changeCoordination(
          memberData?.currentAffectation?.federation?.coordination?.id ?? items[0].id,
          items,
          init,
        )
      } catch (error) {
        console.error(error)
        setCoordinations([])
      }
    }

    const loadInterAndFederations = async (coordination, init = false) => {
      if (!coordination) {
        setInterOrFederations([])
        return
      }
      try {
        const items =
          coordination.children.data ?? (await commonService.load(coordination.children.href))
        coordination.children.data = items

        setInterOrFederations(items)

        if (items.length) {
          let id = null
          if (init) {
            id =
              memberData?.currentAffectation?.federation?.interfederation?.id ??
              memberData?.currentAffectation?.federation?.id
          }
          id = id ?? items[0].id
          await changeInterOrFederation(id, items, init)
        }
      } catch (error) {
        console.error(error)
        setInterOrFederations([])
      }
    }
    const loadFederations = async (parent, init = false) => {
      if (!parent) {
        setFederations([])
        return
      }
      try {
        const items = parent.children.data ?? (await commonService.load(parent.children.href))
        parent.children.data = items

        setFederations(items)
        if (items.length) {
          let id = null
          if (init) {
            id = memberData?.currentAffectation?.federation?.id
          }
          id = id ?? items[0].id
          await changeFederation(id, items, init)
        }
      } catch (error) {
        console.error(error)
        setFederations([])
      }
    }
    const loadSections = async (parent, init = false) => {
      if (!parent) {
        setSections([])
        return
      }
      try {
        const items = parent.children.data ?? (await commonService.load(parent.children.href))
        parent.children.data = items

        setSections(items)
        if (items.length) {
          let id = null
          if (init) {
            id = memberData?.currentAffectation?.section?.id
          }
          id = id ?? items[0].id
          await changeSection(id, items, init)
        }
      } catch (error) {
        console.error(error)
        setSections([])
      }
    }
    const loadCells = async (parent, init = false) => {
      if (!parent) {
        setCells([])
        return
      }
      try {
        const items = parent.children.data ?? (await commonService.load(parent.children.href))
        parent.children.data = items

        setCells(items)
        if (items.length) {
          let id = null
          if (init) {
            id = memberData?.currentAffectation?.cell?.id
          }
          id = id ?? items[0].id
          await changeCell(id, items, init)
        }
      } catch (error) {
        console.error(error)
        setSections([])
      }
    }

    return (
      <CForm
        className="row g-3 needs-validation"
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        <CCol md={4}>
          <CFormLabel htmlFor="subscriptionDateRef">Date d&apos;adhésion</CFormLabel>
          <CFormInput
            ref={subscriptionDateRef}
            type="date"
            id="subscriptionDateRef"
            defaultValue=""
            required
            disabled={autoEnroll}
          />
          <CFormFeedback invalid>La date d&apos;adhésion est requise !</CFormFeedback>
        </CCol>

        <div className="mb-0 mt-4 h6">Affectation actuelle</div>
        {/*showCoordination && (
          <CCol md={4}>
            <CFormLabel htmlFor="coordinationFld">Coordination</CFormLabel>
            <CFormSelect
              id="coordinationFld"
              onChange={(e) => changeCoordination(e.target.value)}
              ref={coordinationIdRef}
              required
            >
              <option disabled>Choisir la coordination</option>
              {coordinations.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </CFormSelect>
            <CFormFeedback invalid>Veuillez renseigner la coordination.</CFormFeedback>
          </CCol>
        )}

        {showInterOrFed && (
          <CCol md={4}>
            <CFormLabel htmlFor="interOrFederationFld">Inter/fédération</CFormLabel>
            <CFormSelect
              id="interOrFederationFld"
              onChange={(e) => changeInterOrFederation(e.target.value)}
              ref={interOrFederationIdRef}
              required
            >
              <option disabled>Choisir la fédération</option>
              {interOrFederations.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.type.id == 1 ? 'Fédération' : 'Interfédération'} {item.name}
                </option>
              ))}
            </CFormSelect>
            <CFormFeedback invalid>Veuillez renseigner la fédération.</CFormFeedback>
          </CCol>
        )}

        {showFed && isInter && (
          <CCol md={4}>
            <CFormLabel htmlFor="federationFld">Fédération</CFormLabel>
            <CFormSelect
              id="federationFld"
              ref={federationIdRef}
              onChange={(e) => changeFederation(e.target.value)}
              required
            >
              <option disabled>Choisir la fédération</option>
              {federations.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </CFormSelect>
            <CFormFeedback invalid>Veuillez indiquer la fédération.</CFormFeedback>
          </CCol>
        )}

        {showSect && (
          <CCol md={4}>
            <CFormLabel htmlFor="sectionFld">Section</CFormLabel>
            <CFormSelect
              id="sectionFld"
              ref={sectionIdRef}
              onChange={(e) => changeSection(e.target.value)}
            >
              <option disabled>Choisir la section</option>
              {sections.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </CFormSelect>
          </CCol>
        )}

        <CCol md={4}>
          <CFormLabel htmlFor="cellFld">Cellule</CFormLabel>
          <CFormSelect id="cellFld" ref={cellIdRef} onChange={(e) => changeCell(e.target.value)}>
            <option disabled>Choisir la cellule</option>
            {cells.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </CFormSelect>
        </CCol>
            */}
        <div>
          <div>
            <span className="info-label">Coordination </span>
            <span className="info-value">
              {memberData.currentAffectation?.federation?.coordination?.name ?? '-'}
            </span>
          </div>
          {memberData.currentAffectation?.federation?.interfederation && (
            <div>
              <span className="info-label">Interfédération </span>
              <span className="info-value">
                {memberData.currentAffectation?.federation?.interfederation?.name ?? '-'}
              </span>
            </div>
          )}
          <div>
            <span className="info-label">Fédération </span>
            <span className="info-value">
              {memberData.currentAffectation?.federation?.name ?? '-'}
            </span>
          </div>
          <div>
            <span className="info-label">Section </span>
            <span className="info-value">
              {memberData.currentAffectation?.section?.name ?? '-'}
            </span>
          </div>
          <div>
            <span className="info-label">Cellule </span>
            <span className="info-value">{memberData.currentAffectation?.cell?.name ?? '-'}</span>
          </div>
        </div>
        <div className="dashed-separator mt-5 mb-4" />
        <div className="d-flex justify-content-between">
          <CButton color="secondary" onClick={() => changeStep(1)}>
            Précédent
          </CButton>
          <CButton color="primary" type="submit">
            Suivant
          </CButton>
        </div>
      </CForm>
    )
  }

  const Review = () => {
    return (
      <div>
        <div className="mb-3 h5">Informations personnelles</div>
        <div className="d-flex">
          <div>
            <CImage
              rounded
              thumbnail
              src={memberData?.photo?.media ?? memberData?.photo?.photoUrl}
              width={200}
              height={200}
              align="start"
              className="me-4"
            />
          </div>

          <div>
            <div className="fw-semibold h6">{memberData?.fullName}</div>
            <div>
              <span>
                {['M', 'F'].includes(memberData.sex)
                  ? memberData.sex === 'M'
                    ? 'Homme'
                    : 'Femme'
                  : '-'}
              </span>{' '}
              &bull; <span>{memberData.maritalStatus}</span>
            </div>

            <div className="dashed-separator mt-1 mb-1" />
            <div>
              <span className="info-label">Né(e) à </span>
              <span className="info-value">{memberData.birthPlace}</span>
            </div>
            <div>
              <span className="info-label">Le </span>
              <span className="info-value">{dateUtil.formatDate(memberData.birthDate)}</span>
            </div>
            <div>
              <span className="info-label">Originaire de </span>
              <span className="info-value">{origin()}</span>
            </div>
            <div className="dashed-separator mt-1 mb-1" />
            <div>
              <span className="info-label">Père </span>
              <span className="info-value">{memberData.fatherFullName ?? '-'}</span>
            </div>
            <div>
              <span className="info-label">Mère </span>
              <span className="info-value">{memberData.motherFullName ?? '-'}</span>
            </div>
            <div className="dashed-separator mt-1 mb-1" />
            <div>
              <span className="info-label">Téléphone </span>
              <span className="info-value">
                {memberData.address.country?.indicator}
                {memberData.phoneNumber ?? '-'}
              </span>
            </div>
            <div>
              <span className="info-label">Email </span>
              <span className="info-value">{memberData.email ?? '-'}</span>
            </div>
            <div className="dashed-separator mt-1 mb-1" />
            <div>
              <span className="info-label">Confession réligieuse </span>
              <span className="info-value">{memberData.religiousDenomination?.name ?? '-'}</span>
            </div>

            <div className="dashed-separator mt-1 mb-1" />
            <div>
              <span className="info-label">Habite à </span>
              <span className="info-value">{address(memberData)}</span>
            </div>
            <div className="dashed-separator mt-1 mb-1" />
            <div className="mb-2 mt-2 h6">Pièce d&apos;identité</div>
            <div className="row">
              <div className="col-9">
                <div>
                  <span className="info-label">Type </span>
                  <span className="info-value">{memberData.idCard?.type?.name ?? '-'}</span>
                </div>
                <div>
                  <span className="info-label">Numéro </span>
                  <span className="info-value">{memberData.idCard?.number ?? '-'}</span>
                </div>
                <div>
                  <span className="info-label">Date d&apos;attribution </span>
                  <span className="info-value">
                    {dateUtil.formatDate(memberData.idCard?.attributionDate) ?? '-'}
                  </span>
                </div>
                <div>
                  <span className="info-label">Date d&apos;invalidation </span>
                  <span className="info-value">
                    {dateUtil.formatDate(memberData.idCard?.invalidationDate) ?? '-'}
                  </span>
                </div>
              </div>

              <div className="col-3">
                <CImage
                  rounded
                  thumbnail
                  src={memberData?.idCard?.illustration ?? memberData?.idCard?.illustrationUrl}
                  width={150}
                  height={150}
                  align="start"
                  className="ms-0"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mb-3 mt-5 h5">Informations partisanes</div>
        <div>
          <span className="info-label">Catégorie </span>
          <span className="info-value">{memberData.category?.name ?? '-'}</span>
        </div>
        <div>
          <span className="info-label">Code de membre </span>
          <span className="info-value">
            {memberData.memberCode2 ?? memberData.memberCode ?? '-'}
          </span>
        </div>
        <div>
          <span className="info-label">Etat </span>
          <span className="info-value">{memberData.status?.name ?? '-'}</span>
        </div>
        <div>
          <span className="info-label">Date d&apos;adhésion </span>
          <span className="info-value">
            {dateUtil.formatDate(memberData.subscriptionDate) ?? '-'}
          </span>
        </div>
        <div>
          <span className="info-label">Date d&apos;enregistrement </span>
          <span className="info-value">{dateUtil.formatDate(memberData.createdAt) ?? '-'}</span>
        </div>
        <div className="dashed-separator mt-1 mb-1" />
        <div className="mb-2 mt-2 h6">Organes</div>
        <div>
          <div>
            <span className="info-label">Coordination </span>
            <span className="info-value">
              {memberData.currentAffectation?.federation?.coordination?.name ?? '-'}
            </span>
          </div>
          {memberData.currentAffectation?.federation?.interfederation && (
            <div>
              <span className="info-label">Interfédération </span>
              <span className="info-value">
                {memberData.currentAffectation?.federation?.interfederation?.name ?? '-'}
              </span>
            </div>
          )}
          <div>
            <span className="info-label">Fédération </span>
            <span className="info-value">
              {memberData.currentAffectation?.federation?.name ?? '-'}
            </span>
          </div>
          <div>
            <span className="info-label">Section </span>
            <span className="info-value">
              {memberData.currentAffectation?.section?.name ?? '-'}
            </span>
          </div>
          <div>
            <span className="info-label">Cellule </span>
            <span className="info-value">{memberData.currentAffectation?.cell?.name ?? '-'}</span>
          </div>
        </div>

        <div className="dashed-separator mt-5 mb-4" />
        <div className="d-flex justify-content-between">
          <CButton color="secondary" onClick={() => changeStep(2)}>
            Précédent
          </CButton>
          <CButton color="primary" onClick={() => save()}>
            Enregistrer
          </CButton>
        </div>
      </div>
    )
  }

  const SaveModal = () => {
    const title = !memberData?.id ? "Confirmation d'ajout" : 'Confirmation de modification'
    const msg = !memberData?.id
      ? "Voulez-vous confirmer l'enrôlement de ce nouveau membre ?"
      : 'Voulez-vous confirmer la modification des informations de ce membre ?'
    return (
      <CModal
        alignment="center"
        visible={saveModalVisible}
        onClose={() => setSaveModalVisible(false)}
      >
        <CModalHeader>
          <CModalTitle>{title}</CModalTitle>
        </CModalHeader>
        <CModalBody>{msg}</CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setSaveModalVisible(false)}>
            Fermer
          </CButton>
          <CButton
            color="primary"
            onClick={async () => {
              setSaveModalVisible(false)
              await save()
            }}
          >
            Valider
          </CButton>
        </CModalFooter>
      </CModal>
    )
  }

  const PhotoModal = ({
    visible,
    setVisible,
    webcam,
    showWebcam,
    photoSrc,
    setPhotoSrc,
    onCrop,
  }) => {
    const webcamRef = useRef()
    const [crop, setCrop] = useState({
      x: 0, //100
      y: 0, //37.5
      width: 300,
      height: 300,
    })
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [zoom, setZoom] = useState(1)
    const [rotation, setRotation] = useState(0)

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
      setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    const capture = useCallback(() => {
      const imageSrc = webcamRef.current.getScreenshot()
      setPhotoSrc(imageSrc)
      showWebcam(false)
    }, [webcamRef])

    const cropPhoto = async () => {
      if (onCrop) {
        const croppedImage = await getCroppedImg(photoSrc, croppedAreaPixels, rotation)

        onCrop(croppedImage)
      }
      setVisible(false)
    }

    const modalVars = {
      '--cui-modal-width': 600,
      '--cui-modal-bg': '#00000030',
    }

    return (
      <CModal
        alignment="center"
        size="lg"
        visible={visible}
        onClose={() => setVisible(false)}
        style={modalVars}
      >
        <CModalHeader>
          <CModalTitle style={{ color: 'white' }}>Photo du membre</CModalTitle>
        </CModalHeader>
        <CModalBody
          className="ps-0 pe-0"
          style={{
            position: 'relative',
            scrollX: 'hidden',
            scrollY: 'hidden',
            paddindTop: 0,
            paddingBottom: 0,
            minHeight: 655,
          }}
        >
          {webcam && <Webcam height={655} width={800} ref={webcamRef} />}
          {!webcam && (
            <>
              <div style={{ position: 'absolute', right: 20, top: 20, zIndex: 20 }}>
                <div
                  style={{
                    display: 'flex',
                    flex: '1',
                    alignItems: 'center',
                  }}
                  className="mb-1"
                >
                  <CIcon
                    icon={cilZoom}
                    style={{ '--ci-primary-color': 'white' }}
                    className="me-1"
                    size="xl"
                  />
                  <input
                    type="range"
                    value={zoom}
                    min={0.5}
                    max={3}
                    step={0.1}
                    aria-labelledby="Zoom"
                    onChange={(e) => {
                      setZoom(e.target.value)
                    }}
                    className="zoom-range"
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    flex: '1',
                    alignItems: 'center',
                  }}
                >
                  <CIcon
                    icon={cilCropRotate}
                    style={{ '--ci-primary-color': 'white' }}
                    className="me-1"
                    size="xl"
                  />
                  <input
                    type="range"
                    value={rotation}
                    min={0}
                    max={360}
                    step={1}
                    aria-labelledby="Rotation"
                    onChange={(e) => {
                      setRotation(e.target.value)
                    }}
                    className="zoom-range"
                  />
                </div>
              </div>
              <div className="crop-container">
                <Cropper
                  image={photoSrc}
                  crop={crop}
                  zoom={zoom}
                  rotation={rotation}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onRotationChange={setRotation}
                  onCropComplete={onCropComplete}
                  aspect={3 / 3}
                />
              </div>
              {/** 
     * onMediaLoaded={(mediaSize) => {
        // Adapt zoom based on media size to fit max height
        onZoomChange(CONTAINER_HEIGHT / mediaSize.naturalHeight)
      }}

      <ReactCrop crop={crop} onChange={(c) => setCrop(c)} locked>
                  <img
                    src={webcamPhotoSrc}
                    onLoad={onImageLoad}
                    style={{ transform: `scale(${imageScale})` }}
                  />
                </ReactCrop>
     * 
    */}
            </>
          )}
        </CModalBody>
        <CModalFooter className="d-flex align-items-center justify-content-center">
          <CButton
            color="primary"
            shape="rounded-pill"
            onClick={() => {
              webcam ? capture() : cropPhoto()
            }}
            style={{
              '--cui-btn-padding-x': 10,
              '--cui-btn-padding-y': 15,
              '--cui-btn-bg': '#00000090',
              '--cui-btn-border-color': 'transparent',
              width: 50,
              height: 50,
            }}
          >
            <CIcon icon={webcam ? cilMediaRecord : cilCheckAlt} size="xxl" />
          </CButton>
        </CModalFooter>
      </CModal>
    )
  }

  const showSaveModal = () => {
    setSaveModalVisible(true)
    console.log('Save click')
  }
  const save = async () => {
    setLoading(true)
    const _member = structuredClone(memberData)
    _member.birthDate = dateUtil.formatDateDB(_member.birthDate)
    _member.originQuarter = { id: _member.originQuarter.id }
    if (_member.originVillage) _member.originVillage = { id: _member.originVillage.id }
    _member.category = { id: _member.category.id }
    _member.birthCountry = { code: _member.birthCountry.code }
    if (_member.address.village) _member.address.village = { id: _member.address.village.id }
    if (_member.address.quarter) _member.address.quarter = { id: _member.address.quarter.id }
    if (_member.address.city) _member.address.city = { id: _member.address.city.id }
    if (_member.address.country) _member.address.country = { code: _member.address.country.code }

    _member.currentAffectation.federation = { id: _member.currentAffectation.federation.id }
    if (_member.currentAffectation.section)
      _member.currentAffectation.section = { id: _member.currentAffectation.section.id }
    if (_member.currentAffectation.cell)
      _member.currentAffectation.cell = { id: _member.currentAffectation.cell.id }

    _member.status = { id: _member.status.id }
    _member.religiousDenomination = { id: _member.religiousDenomination.id }
    if (_member.idCard) {
      if (_member.idCard.type.name.trim() === 'AUCUNE') {
        _member.idCard = null
      } else {
        _member.idCard.type = { id: _member.idCard.type.id }
        _member.idCard.invalidationDate =
          _member.idCard.invalidationDate !== '' ? _member.idCard.invalidationDate : null
      }
    }

    try {
      const feed = member.id
        ? await memberService.update(_member)
        : await memberService.add(_member)
      setLoading(false)
      if (feed && 'id' in feed) {
        if (autoEnroll) {
          dispatch(fetchAutoEnrolled(_member))
          addToast(successToast(`Votre adhésion est enregistrée avec succès !`))
          await sleep(3000)
          navigate(`/members/enroll/finish`, { replace: true })
        } else {
          addToast(successToast(`Membre ${member.id ? 'modifié' : 'ajouté'} avec succès !`))
          await sleep(3000)
          navigate(`/members/${feed.id}`, { replace: true })
        }
      } else {
        if (autoEnroll) {
          const msg =
            "Nous n'avons pas pu vous enregistrer pour l'instant. Vérifiez que vous êtes toujours connecté(e) à Internet, puis réassayez."
          addToast(failureToast(msg))
        } else {
          const msg = (member.id ? 'Modification' : 'Ajout') + 'échoué. Une erreur est survenue.'
          addToast(failureToast(msg))
        }
      }
    } catch (error) {
      setLoading(false)
      if (autoEnroll) {
        const msg =
          "Nous n'avons pas pu vous enregistrer pour l'instant. Vérifiez que vous êtes toujours connecté(e) à Internet, puis réassayez."
        addToast(failureToast(msg))
      } else {
        const msg = (member.id ? 'Modification' : 'Ajout') + 'échoué. Une erreur est survenue.'
        addToast(failureToast(msg))
      }
      addToast(failureToast(member.id))
      console.error(error)
    }
  }

  return (
    <div className={autoEnroll ? 'container-lg' : ''} style={{ marginTop: autoEnroll ? 20 : 0 }}>
      <CRow>
        <CCol xs>
          <CCard className="mb-4">
            <CCardHeader className="d-flex">
              Formulaire d&apos;enrôlement du membre au parti{' '}
              {autoEnroll && <b>&nbsp;Ensemble pour la République</b>}
            </CCardHeader>
            <CCardBody>
              <CAlert
                color="success"
                className="d-flex align-items-center"
                visible={successAlertVisible}
              >
                <CIcon
                  icon={cilCheckCircle}
                  className="flex-shrink-0 me-2"
                  width={24}
                  height={24}
                />
                <div>Données enregistrées avec succès !</div>
              </CAlert>
              <CAlert
                color="danger"
                className="d-flex align-items-center"
                visible={failureAlertVisible}
                dismissible
                onClose={() => setFailureAlertVisible(false)}
              >
                <CIcon icon={cilXCircle} className="flex-shrink-0 me-2" width={24} height={24} />
                <div>
                  Enregistrement échoué ! Une erreur s&apos;est produite. Veuillez recommencer plus
                  tard.
                </div>
              </CAlert>

              {autoEnroll && (
                <CRow className="mb-2">
                  <div className="h3">Auto-adhésion</div>
                  <CCol sm="10">
                    <div className="text-medium-emphasis">
                      Merci de vous joindre à nous. Veuillez compléter vos informations personnelles
                      dans le formulaire ci-dessous. Après votre enregistrement, nous vous
                      conseillons de vous rendre le plus tôt que possible dans l&apos;organe où vous
                      serez affecté(e) pour vous procurer votre carte de membre.{' '}
                    </div>
                  </CCol>
                  <CCol sm="2">
                    <CImage src={logo} height={90} style={{ marginRight: 10 }} />
                  </CCol>
                </CRow>
              )}
              <div className={`register-step-header ${step1 ? 'register-step-active' : ''}`}>
                <span className="number">1</span>
                <span className="h5 mt-0 mb-0">Informations personnelles</span>
              </div>
              {step1 && (
                <>
                  <PersonalInfo />
                  <div className="mb-5"></div>
                </>
              )}

              <div className={`register-step-header ${step2 ? 'register-step-active' : ''}`}>
                <span className="number">2</span>
                <span className="h5 mt-0 mb-0">Informations partisanes</span>
              </div>
              {step2 && (
                <>
                  <PartisanInfo />
                  <div className="mb-5"></div>
                </>
              )}

              <div className={`register-step-header ${step3 ? 'register-step-active' : ''}`}>
                <span className="number">3</span>
                <span className="h5 mt-0 mb-0">Vérification et validation</span>
              </div>
              {step3 && (
                <>
                  <Review />
                  <div className="mb-5"></div>
                </>
              )}
              <SaveModal />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      {loading && (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            backgroundColor: '#00000040',
          }}
        >
          <CSpinner color="white" />
        </div>
      )}
      <CToaster ref={toaster} push={toast} placement="top-center" />
    </div>
  )
}

export default MemberEdit
